import React from 'react';

import { Modal } from 'src/components/common';
import { ResendInviteModalContent } from 'src/components/invite';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import type { ResendInviteModalArgs } from './types';

export const ResendInviteModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } = useModal<ResendInviteModalArgs>(
    ModalId.ResendInvite,
  );

  const handleModalClose = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (!isOpen) return null;
  if (!args?.toStaff || !args?.staffEmail || !args?.onSubmit) {
    throw new Error('ResendInviteModal: Missing required arguments');
  }

  return (
    <Modal
      title={`Resend Invite to ${args?.toStaff} staff`}
      maxWidth={480}
      headerProps={{
        sx: { pb: 0 },
      }}
      dialogProps={{
        fullWidth: true,
        onClose: handleModalClose,
        open: isOpen,
      }}
    >
      <ResendInviteModalContent
        onCloseModal={handleModalClose}
        switchClosability={switchClosability}
        toStaff={args.toStaff}
        staffEmail={args.staffEmail}
        onSubmit={args.onSubmit}
      />
    </Modal>
  );
};
